import Isotope from 'isotope-layout';

export function isotopeInit(){
    var elem = document.querySelector('.question');
    var iso = new Isotope( elem, {
    // options
    itemSelector: '.question-item',
    percentPosition: true,
    masonry: {
        // use element for option
        columnWidth: '.grid-sizer',
        gutter: 16
      }
    });

    return iso;
}